import { config } from "zod"

// Run before application schemas are created: even Zod's caught eval probe
// emits a CSP violation. Keep schema-bearing imports out of this entrypoint.
config({ jitless: true })
